import React from 'react';
import Button from '@atlaskit/button';
import StarFilledIcon from '@atlaskit/icon/glyph/send';

import PropTypes from 'prop-types';

export const IconButton = ({
  disabled,
  ...props
}) => (
  <Button
    iconAfter={<StarFilledIcon label="" size="medium" />}
    appearance="primary"
    aria-label="Unstar this page"
    isDisabled={disabled} // Використовуємо isDisabled
    {...props}
  />
);

IconButton.propTypes = {
  disabled: PropTypes.bool,
};

IconButton.defaultProps = {
  disabled: false,
};

export default IconButton;
